import { Shell } from 'lucide-react';
import type { ReactNode } from 'react';

export default function PageLead({ eyebrow, title, subtitle, imageClass }: { eyebrow: string; title: ReactNode; subtitle?: ReactNode; imageClass?: string }) {
  return (
    <section className={imageClass ? `page-lead ${imageClass}` : 'page-lead'}>
      <div className="container-wide page-lead-inner">
        <div className="page-lead-copy">
          <span className="eyebrow">{eyebrow}</span>
          <div className="mini-wave" />
          <h1>{title}</h1>
          {subtitle && <div className="page-subtitle">{subtitle}</div>}
          <div className="shell-rule"><Shell size={28} /><span /></div>
        </div>
      </div>
    </section>
  );
}
